import { useEffect, useRef } from "react"

import { usePageLayout } from "~contexts/page-layout-provider"

/**
 * Collapses the left nav while the assistant ("Susie") is open so the panel has
 * room, then restores the sidebar to its previous open/collapsed state once the
 * assistant closes.
 *
 * @param isAssistantOpen - Whether the outfitter assistant panel is currently open.
 */
export default function useCollapseSidebarWhenAssistantOpens(
    isAssistantOpen: boolean
) {
    const { isSidebarOpen, openSidebar, closeSidebar } = usePageLayout()

    // Keep the latest layout state/handlers in a ref so the effect only reacts
    // to the assistant opening/closing — not to every sidebar toggle.
    const layoutRef = useRef({ isSidebarOpen, openSidebar, closeSidebar })
    layoutRef.current = { isSidebarOpen, openSidebar, closeSidebar }

    const sidebarWasOpenRef = useRef<boolean | null>(null)

    useEffect(() => {
        const layout = layoutRef.current

        if (isAssistantOpen) {
            sidebarWasOpenRef.current = layout.isSidebarOpen
            layout.closeSidebar()
            return
        }

        if (sidebarWasOpenRef.current === null) return

        if (sidebarWasOpenRef.current) layout.openSidebar()
        sidebarWasOpenRef.current = null
    }, [isAssistantOpen])
}
